import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Marigold Mandap',
    description: "Indian wedding planners for every ritual from roka to vidaai. Full planning, wedding week management and destination weddings across India and abroad.",
    url: getOrigin(),
    studio: "Studio in Mumbai, planning across India and abroad",
    hours: "Monday to Saturday, 10 am to 7 pm IST"
}
